import ReactDOM from 'react-dom'

import { MenuPlacement } from 'react-select/dist/declarations/src/types'
import TooltipSelect from './TooltipSelect'
import { getTargets } from './tooltip-select.selector'

const TooltipSelectComponent = (() => {
	const init = (scope?: HTMLElement) => {
		const targets = getTargets(scope)
		if (targets.length === 0) return

		targets.forEach((target) => {
			const getDataHandler = target.dataset.tooltipSelectGetDataHandler
			const menuPlacement = (target.dataset.tooltipSelectMenuPlacement as MenuPlacement) ?? 'top'
			const placeholder = target.dataset.tooltipSelectPlaceholder ?? ''
			if (!getDataHandler) return

			ReactDOM.render(
				<TooltipSelect getDataHandler={getDataHandler} menuPlacement={menuPlacement} placeholder={placeholder} />,
				target,
			)
		})
	}

	return { init }
})()
export default TooltipSelectComponent
